export default "__VITE_ASSET__B_qzIhu2__"